import React, { useEffect, useState } from "react";

export function AgentCopyButton({ text, label = "Copy prompt", disabled = false }: {
  text: string; label?: string; disabled?: boolean;
}) {
  const [status, setStatus] = useState<"idle" | "copied" | "error">("idle");
  useEffect(() => { setStatus("idle"); }, [text]);
  useEffect(() => {
    if (status !== "copied") return;
    const timer = window.setTimeout(() => setStatus("idle"), 2500);
    return () => window.clearTimeout(timer);
  }, [status]);
  async function copy() {
    try { await navigator.clipboard.writeText(text); setStatus("copied"); }
    catch { setStatus("error"); }
  }
  return <span className="agent-copy-control">
    <button type="button" className="agent-copy-button" disabled={disabled} onClick={copy}
      aria-label={status === "copied" ? "Copied" : label}>
      <span className="agent-copy-logos" aria-hidden="true">
        {["claude", "openai", "cursor"].map(agent => <span key={agent}>
          <img src={`/images/agents/${agent}.svg`} width="18" height="18" alt="" />
        </span>)}
      </span>
      <span className="agent-copy-label">{status === "copied" ? "Copied" : label}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        {status === "copied" ? <path d="m5 12 4 4L19 6" /> : <><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8V4H4v12h4" /></>}
      </svg>
    </button>
    <span role="status" className="agent-copy-status">{status === "copied" ? "Copied to clipboard." : ""}</span>
    {status === "error" && <div className="agent-copy-fallback">
      <p role="alert">Could not copy. Select and copy the prompt below.</p>
      <textarea aria-label="Run prompt" readOnly value={text} onFocus={event => event.currentTarget.select()} />
    </div>}
  </span>;
}
